exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".welcome{background:#fff;position:fixed;top:0;left:0;width:100vw;height:100vh;text-align:center;display:flex;flex-direction:column;justify-content:center}.welcome .setup-logo-container{position:absolute;text-align:left;top:0}.welcome__benefits{max-width:550px;margin-left:auto;margin-right:auto}.welcome__benefits__item{display:flex;flex-wrap:nowrap;align-items:center}.welcome__buttons{margin-bottom:24px}.welcome__variant-b-container{max-width:550px;margin-left:auto;margin-right:auto;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/containers/chargeContainer.scss
// module id = 1317
// module chunks = 0